export default __webpack_public_path__ + "assets/linkedIn.324d1ac3.svg";